import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../api/axios';
import { Search } from 'lucide-react';

const statusBadge = s => {
  const map = {
    PRESENT:'badge-green', ABSENT:'badge-red',
    HALF_DAY:'badge-amber', LEAVE:'badge-purple',
    HOLIDAY:'badge-blue', WEEKLY_OFF:'badge-muted'
  };
  return <span className={`badge ${map[s]||'badge-muted'}`}>{s?.replace('_',' ')}</span>;
};

export default function AttendancePage() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [date, setDate]       = useState(new Date().toISOString().split('T')[0]);

  const load = () => {
    setLoading(true);
    api.get(`/attendance/?date=${date}&page_size=100`)
      .then(r => setRecords(r.data.results || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [date]);

  const present = records.filter(r => r.status === 'PRESENT').length;
  const absent  = records.filter(r => r.status === 'ABSENT').length;
  const half    = records.filter(r => r.status === 'HALF_DAY').length;

  return (
    <Layout
      title="Attendance"
      subtitle="Daily attendance tracking"
      actions={
        <input type="date" className="form-input" style={{ width:'auto' }}
          value={date} onChange={e => setDate(e.target.value)}/>
      }
    >
      <div className="kpi-grid" style={{ gridTemplateColumns:'repeat(3,1fr)', marginBottom:20 }}>
        <div className="kpi-card green">
          <div className="kpi-value">{present}</div>
          <div className="kpi-label">Present</div>
        </div>
        <div className="kpi-card red">
          <div className="kpi-value">{absent}</div>
          <div className="kpi-label">Absent</div>
        </div>
        <div className="kpi-card amber">
          <div className="kpi-value">{half}</div>
          <div className="kpi-label">Half Day</div>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div className="loading"><div className="spinner"/>Loading...</div>
        ) : records.length === 0 ? (
          <div className="empty-state"><p>No attendance records for {date}.</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Employee ID</th><th>Name</th><th>Status</th>
                  <th>Punch In</th><th>Punch Out</th>
                  <th>Hours</th><th>Daily Wage</th><th>Source</th>
                </tr>
              </thead>
              <tbody>
                {records.map(r => (
                  <tr key={r.id}>
                    <td style={{ color:'var(--brand)', fontWeight:600 }}>{r.employee_code}</td>
                    <td style={{ fontWeight:600, color:'var(--text-primary)' }}>{r.employee_name}</td>
                    <td>{statusBadge(r.status)}</td>
                    <td>{r.punch_in || '—'}</td>
                    <td>{r.punch_out || '—'}</td>
                    <td>{r.total_hours ? `${r.total_hours}h` : '—'}</td>
                    <td>{r.daily_wage ? `₹${r.daily_wage}` : '—'}</td>
                    <td><span className="badge badge-muted">{r.source}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
